import React from 'react'
import Layout from "../components/layout"
import SEO from "../components/seo"


const AboutPage = () => (
    <Layout>
        <SEO title="About" />
        <h1>ABOUT</h1>
        <p>Hi, I'm Taqwa — a front-end software engineer based in Chicago with 5+ years of experience building sleek, performant, and accessible web experiences for a diverse set of brands.</p>

        <p>I'm currently a Software Engineer at <a className="inner-link" href="https://www.wideeye.co/" target="_blank" rel="noopener noreferrer">Wide Eye</a>, a digital creative agency for purpose-driven organizations and changemakers, where I build custom Gutenberg blocks, do accessibility remediation work, and manage a portfolio of 20+ client websites. Before that, I spent time at Loyal Health building patient- and provider-facing search and scheduling tools deployed across 50+ hospital systems, and at Blue State, a mission-driven marketing and ad-tech agency, where I built products for political campaigns and progressive causes and helped found their Component Library Working Group.</p>

        <p>Day to day, I work mostly in PHP, React, TypeScript, and Node, with a soft spot for clean component architecture, accessible UI, and design systems that make life easier for the next developer. I care a lot about the details; the kind of performance and accessibility work that users feel even when they can't name it.</p>
    </Layout>
)

export default AboutPage;
